// extracted by mini-css-extract-plugin
export default {"threedotsBtn":"style_threedotsBtn__x2qbQ"};